<div class="cell cell-large-col-span-12 open-tile-block-container" [ngClass]="tileClass ? tileClass : ''" tabindex="0" [class]="noAction ? 'noAction' : ''" (click)="tileAction()" >
  <div class="padding-small open-tile-block">

    <!-- Tile notification icon -->
    <div class="open-tile-block-icon" *ngIf="tileClass.indexOf('notification') > -1">
      <open-svg-icon  *ngIf="tileClass === 'info-notification' && !!icon" [name]="icon" class="small margin-right-xxsmall"></open-svg-icon>
      <open-svg-icon  *ngIf="tileClass === 'error-notification'" [name]="'communication-alert'" class="small margin-right-xxsmall"></open-svg-icon>
    </div>

    <div class="open-tile-block-details">
      <!-- Tile content text -->
      <h4 *ngIf="tileClass !== 'tertiary'">{{ title }}</h4>
      <strong *ngIf="tileClass === 'tertiary'">{{ title }}</strong>
      <span class="text-xsmall" [ngClass]="{ 'margin-bottom-xsmall': tileClass === '' }" [innerHtml]="text"></span>

      <!-- This section is used to render dynamic tags -->
      <ng-content></ng-content>

    </div>

    <!-- Arrow icon indicating tile is clickable. All classes except 'tertiary' -->
    <div *ngIf="tileClass !== 'tertiary' && !noAction" class="open-tile-block-link">
      <mat-icon class="east"></mat-icon>
    </div>

    <!-- For tertiary state/style this displays a link. Whole tile is NOT clickable when this is used -->
    <div *ngIf="tileClass === 'tertiary' && !noAction" class="open-tile-block-link">
      <div class="flex">
        <mat-spinner diameter="20" *ngIf="actionInProgress" class="margin-right-xsmall"></mat-spinner>
        <a class="small" (click)="executeAction()" [ngClass]="actionInProgress ? 'disabled' : ''">{{ actionText }}</a>
      </div>
    </div>

  </div>
</div>
